import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionForm_Actors_Customize_Mutation = graphql(`
  mutation MissionForm_Actors_Customize(
    $actorableId: Id!
    $list: ActorListEnum!
    $versionData: VersionDataInput
  ) {
    customizeMissionActors(
      actorableId: $actorableId
      list: $list
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useCustomizeMissionActorsMutation = () =>
  useGraphQLMutation(MissionForm_Actors_Customize_Mutation);
